{
  "intro": "TLS-сертификаты для HTTPS-сервисов балансировщиков: собственные — загружаются вместе с закрытым ключом, или управляемые — провайдер получает их в Let's Encrypt для ваших доменов и сам продлевает.",
  "empty": "Сертификатов пока нет",
  "emptyLead": "HTTPS-сервису балансировщика нужен сертификат для его доменов. Пусть его выпустят и продлевают за вас — или загрузите свой.",
  "create": "Добавить сертификат",
  "createLead": "Управляемый — самый простой путь; свой загружайте, если он у вас уже есть.",
  "kind": "Вид",
  "kinds": {
    "managed": "Управляемый (Let's Encrypt)",
    "uploaded": "Загруженный"
  },
  "kindHints": {
    "managed": "Выпускается и продлевается автоматически для указанных доменов. Их DNS-зоны должны быть в Hetzner DNS.",
    "uploaded": "Ваш сертификат и закрытый ключ в формате PEM. Продлевать его до истечения срока — ваша забота."
  },
  "name": "Имя",
  "nameHint": "Чтобы узнавать его при выборе сертификата для сервиса.",
  "domains": "Домены",
  "domainsHint": "По одному в строке; *.example.com покрывает поддомены на один уровень ниже.",
  "domainsInvalid": "Укажите хотя бы один домен, например example.com. Не домен: {{domain}}",
  "managedDnsNote": "Провайдер подтверждает домены через DNS: их зоны должны быть в Hetzner DNS, иначе выпуск не удастся. Это может занять несколько минут.",
  "certificate": "Сертификат (PEM)",
  "certificateHint": "Сначала ваш сертификат, затем промежуточные.",
  "pemInvalid": "Вставьте сертификат в формате PEM, начиная с -----BEGIN CERTIFICATE-----.",
  "privateKey": "Закрытый ключ (PEM)",
  "privateKeyHint": "Уходит сразу провайдеру. CloudServer его не хранит, не показывает повторно и не пишет в журналы.",
  "keyInvalid": "Вставьте закрытый ключ в формате PEM, начиная с -----BEGIN PRIVATE KEY-----.",
  "requestSubmit": "Запросить сертификат",
  "uploadSubmit": "Загрузить сертификат",
  "requested": "Сертификат {{name}} запрошен; выпуск займёт несколько минут",
  "uploaded": "Сертификат {{name}} загружен",
  "labels": "Метки",
  "edit": "Имя и метки",
  "editTitle": "Сертификат {{name}}",
  "retry": "Повторить выпуск",
  "retrying": "Снова пробуем выпустить {{name}}…",
  "stateTitle": "Состояние",
  "state": {
    "pending": "Выпускается",
    "failed": "Выпуск не удался",
    "renewalFailed": "Продление не удалось",
    "expired": "Истёк",
    "soon": "Скоро истекает",
    "valid": "Действует",
    "unknown": "Неизвестно"
  },
  "expires": "Действует до",
  "usedBy": "Используется",
  "unused": "Не используется",
  "createdAt": "Добавлен",
  "why": {
    "inUse": "Его использует балансировщик; сначала уберите его из HTTPS-сервисов",
    "notFailed": "Повторить можно только неудавшийся выпуск или продление"
  },
  "delete": "Удалить сертификат",
  "deleteTitle": "Удалить сертификат {{name}}?",
  "deleteGone": "Его больше нельзя будет выбрать для HTTPS-сервисов.",
  "deleteKey": "Провайдер удалит и его закрытый ключ; чтобы использовать сертификат снова, загрузите его заново.",
  "deleted": "Сертификат {{name}} удалён"
}
